import { Component, Input, OnInit } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { checkmarkIcon, crossLightIcon } from '../../../icons';
import { FieldBaseComponent } from '../field-base/field-base.model';

export interface IDatePickerFormat {
    year: number;
    month: number;
    day: number;
}

@Component({
    selector: 'app-datepicker',
    template: `
        <div class="input" [formGroup]="parentForm">
            <label>
                <input
                    ngbDatepicker
                    class="input__input-element"
                    [ngClass]="cssClasses"
                    autocomplete="off"
                    [formControlName]="controlName"
                    [autoClose]="true"
                    #dp="ngbDatepicker"
                    (click)="dp.open()"
                    (focus)="!dontOpenDatepicker && dp.open(); dontOpenDatepicker = dp.isOpen()"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [class.input__input-element--not-empty]="inputControl?.value"
                    [markDisabled]="disabledDays"
                />

                <span class="input__label">{{ label }}</span>
                <span class="input__validation-icon">
                    <i aria-hidden="true" class="input__icon" *ngIf="inputControl?.errors; else validTmpl">${crossLightIcon}</i>
                    <ng-template #validTmpl>
                        <i aria-hidden="true" class="input__icon">${checkmarkIcon}</i>
                    </ng-template>
                </span>

                <p class="help is-danger" *ngIf="inputControl?.errors && inputControl?.touched">
                    <ng-container *ngIf="inputControl?.errors?.required">
                        {{ 'forms.validation_message____field_required' | translate }}
                    </ng-container>
                </p>
            </label>
        </div>
    `,
})
export class DatepickerComponent extends FieldBaseComponent implements OnInit {
    @Input() cssClasses: string;
    @Input() label: string;
    @Input() type = 'text';
    @Input() set daysToDelayMinDate(value: number) {
        this._daysToDelayMinDate = value;
        this.setDatePickerSettings();
    }
    @Input() disabledDays: (date: NgbDate, current: { month: number } | undefined) => boolean;
    dontOpenDatepicker = false;
    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;

    private _daysToDelayMinDate = 0;

    constructor() {
        super();
    }

    ngOnInit() {
        this.setDatePickerSettings();
    }

    setDatePickerSettings() {
        const currentDate = new Date();
        const disabledFromDate = new Date(currentDate.setDate(currentDate.getDate() + this._daysToDelayMinDate));

        this.minDate = {
            day: disabledFromDate.getDate(),
            month: disabledFromDate.getMonth() + 1,
            year: disabledFromDate.getFullYear(),
        };

        this.maxDate = {
            day: currentDate.getDate(),
            month: currentDate.getMonth() + 1,
            year: currentDate.getFullYear() + 2,
        };
    }
}
